import { useSseStream } from './useSseStream';

const BACKEND = process.env.REACT_APP_BACKEND_WORKER_URL;

/**
 * Platform event stream for one or more topics (e.g. ["leads:abc-123", "analyses:abc-123"]).
 *
 * @param {string[]} topics
 * @param {object} options
 * @param {boolean} options.enabled - whether to open connection (default: true)
 * @param {function} options.onEvent - callback for each event: (eventType, data) => void
 * @param {string[][]} options.invalidateKeys - React Query keys to invalidate on any event
 */
export function useServerEvents(topics, options = {}) {
	const topicsKey = topics?.join(',');
	const url = topicsKey ? `${BACKEND}/api/v1/platform/events/stream?topics=${encodeURIComponent(topicsKey)}` : null;
	useSseStream(url, { ...options, resolveUrl: () => url });
}
